exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected[data-v-4296ef21]{background-color:var(--LS-admintheme-hintedbasecolor)}.selected[data-v-4296ef21]:after{position:absolute;right:10px;content:\"\\F054\";font:normal normal normal 18px/1 FontAwesome;text-rendering:auto}.scope-attack-padding[data-v-4296ef21]{padding:1%;margin:2px}.scoped-overflow-scroll[data-v-4296ef21]{height:100%;overflow-y:auto;overflow-x:hidden}", ""]);

// exports
